import type * as React from 'react';
import useIsCompactViewport from '@Guidelines/Component/FilterPanel/Hooks/useIsCompactViewport';
import ConditionalLoader from '@Guidelines/Component/Loader/ConditionalLoader';

type Props = {
	children: React.ReactNode;
	whenCompact: React.ReactNode;
};

const ConditionalViewPort: React.FC<Props> = ({ children, whenCompact }) => {
	const isCompact = useIsCompactViewport();

	return (
		<ConditionalLoader data={!isCompact} fallback={whenCompact}>
			{children}
		</ConditionalLoader>
	);
};

export default ConditionalViewPort;
